module.exports = __webpack_public_path__ + "img/goods.3a6a3e1a.png";